// import React, { useEffect, useState } from 'react'
// import { Link } from 'react-router-dom'
// import MobileMenu from '../MobileMenu/MobileMenu'
// import HeaderProfileForm from '../HeaderProfileForm/HeaderProfileForm';
// import { connect } from "react-redux";
// import { removeFromCart } from "../../store/actions/action";
// import { useProjects } from '../../api/ProjectsContext';

// const Header = (props) => {

// const {causesData } = useProjects();

//     const ClickHandler = () => {
//         window.scrollTo(10, 0);
//     }

//     return (
//         <header id="header">
//             <div className={"wpo-site-header " + props.hclass}>
//                 <nav className="navigation navbar navbar-expand-lg navbar-light">
//                     <div className="container-fluid w-100">
//                         <div className="row align-items-center justify-space-between">

//                             <div className="col-lg-3 col-md-5 col-6">
//                                 <div className="navbar-header">
//                                     <Link onClick={ClickHandler} className="navbar-brand" to="/"><img src={props.Logo}
//                                         alt="logo" style={{width:"242px", height:"60px"}}/></Link>
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-md-1 col-1">
//                                 <div id="navbar" className="collapse navbar-collapse navigation-holder">
//                                     <ul className="nav navbar-nav mb-2 mb-lg-0">
//                                         <li className="menu-item-has-children">
//                                             <Link onClick={ClickHandler} to="/">Home</Link>

//                                         </li>

//                                   <li className="menu-item-has-children" >
//                                             <Link onClick={ClickHandler} to="/projects">Explore</Link>
//                                             <ul className="sub-menu" style={{ maxHeight: "300px", overflowY: "auto", position: "absolute", background: "#fff", zIndex: 1000, width: "400px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)", borderRadius: "5px" }}>
//                                                 {[
//                                                     "Agriculture",
//                                                     "Community Building",
//                                                      "Education",
//                                                     "Food",
//                                                      "Health",
//                                                      "Human Rights",
//                                                          "ICT",
//                                                     "Media & Journalism",
//                                                       "Water",
//                                                    "Health and Environmental Security"
//                                                 ].map((category, index)=> (
//                                                     <li key={index}>
//                                                         <Link onClick={ClickHandler} to={`/projects/category/${encodeURIComponent(category)}`}>
//                                                             {category}
//                                                         </Link>
//                                                     </li>
//                                                 ))}
//                                             </ul>
//                                         </li>

//                                         <li className="menu-item-has-children">
//                                             <Link onClick={ClickHandler} to="">Pages</Link>
//                                             <ul className="sub-menu">
//                                                 <li><Link onClick={ClickHandler} to="/about">About</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/how-it-works">How it works</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/privacy">Privacy Policy</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/terms">Terms Of Use</Link></li>

//                                             </ul>
//                                         </li>

//                                     </ul>
//                                 </div>
//                             </div>
//                             <div className="col-lg-3 col-md-3 col-2">
//                                 <div className="header-right">

//                                     <HeaderProfileForm />
//                                    <MobileMenu />
//                                 </div>
//                             </div>
//                             <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block ">

//                              </div>
//                         </div>
//                     </div>
//                 </nav>
//             </div>
//         </header>
//     )
// }

// const mapStateToProps = (state) => {
//     return {
//         carts: state.cartList.cart,
//     };
// };

// export default connect(mapStateToProps, { removeFromCart })(Header);

// I18N — Header navigation labels and category names are translated via react-i18next.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MobileMenu from "../MobileMenu/MobileMenu";
import HeaderProfileForm from "../HeaderProfileForm/HeaderProfileForm";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher"; // I18N
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import { useProjects } from "../../api/ProjectsContext";

const CATEGORIES = [
  "Agriculture",
  "Community Building",
  "Education",
  "Food",
  "Health",
  "Human Rights",
  "ICT",
  "Media & Journalism",
  "Water",
  "Health and Environmental Security",
];

const Header = (props) => {
  const { causesData } = useProjects();
  const { t } = useTranslation();

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <header id="header">
      <div className={"wpo-site-header " + props.hclass}>
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid w-100">
            <div className="row align-items-center justify-content-between w-100">
              <div className="col-lg-3 col-md-4 col-sm-4 col-5">
                <div className="navbar-header">
                  <Link onClick={ClickHandler} className="navbar-brand" to="/">
                    <img
                      src={props.Logo}
                      alt="logo"
                      style={{ width: "242px", height: "60px" }}
                    />
                  </Link>
                </div>
              </div>

              <div className="col-lg-6 d-none d-lg-block">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    <li className="menu-item-has-children">
                      <Link
                        onClick={ClickHandler}
                        to="/"
                        style={{ fontWeight: "550" }}
                      >
                        {t("nav.home")}
                      </Link>
                    </li>
                    <li className="menu-item-has-children">
                      <Link
                        onClick={ClickHandler}
                        to="/projects"
                        style={{ fontWeight: "550" }}
                      >
                        {t("nav.explore")}
                      </Link>
                      <ul
                        className="sub-menu"
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          position: "absolute",
                          background: "#fff",
                          zIndex: 1000,
                          width: "400px",
                          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                          borderRadius: "5px",
                        }}
                      >
                        {CATEGORIES.map((category, index) => (
                          <li key={index}>
                            <Link
                              onClick={ClickHandler}
                              to={`/projects/category/${encodeURIComponent(category)}`}
                            >
                              {t(`categories.${category}`, category)}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                    <li className="menu-item-has-children">
                      <Link
                        onClick={ClickHandler}
                        to="/partners"
                        style={{ fontWeight: "550" }}
                      >
                        {t("nav.partners")}
                      </Link>
                    </li>
                    <li className="menu-item-has-children">
                      <Link
                        onClick={ClickHandler}
                        to=""
                        style={{ fontWeight: "550" }}
                      >
                        {t("nav.pages")}
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link onClick={ClickHandler} to="/about">
                            {t("nav.about")}
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/contact">
                            {t("nav.contact")}
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/how-it-works">
                            {t("nav.howItWorks")}
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/privacy">
                            {t("nav.privacy")}
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/terms">
                            {t("nav.terms")}
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-8 col-sm-8 col-7">
                <div className="header-right d-flex align-items-center justify-content-end">
                  <div className="d-none d-lg-block">
                    <LanguageSwitcher />
                  </div>
                  <div className="ms-3 d-none d-lg-block">
                    <HeaderProfileForm />
                  </div>
                  <div className="ms-3 ">
                    <MobileMenu />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
  };
};

export default connect(mapStateToProps, { removeFromCart })(Header);
